'use strict';

module.exports = require('./src/');


// WEBPACK FOOTER //
// ./index.js